import { ChangeReportEntity } from './change-report-entity.model';
import { PaymentStream } from './payment-stream.model';

export class ChangeReportTransaction {
  payingEntity: ChangeReportEntity;
  receivingEntity: ChangeReportEntity;
  stream: PaymentStream;
  constructor (data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.payingEntity = new ChangeReportEntity();
      this.receivingEntity = new ChangeReportEntity();
      this.stream = new PaymentStream();
    }
  }
}
